export function checkIfIndexedDbIsSupported(): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      const result = indexedDB.open("_isIndexedDbSupported")
      result.onsuccess = () => resolve(true)

      // Chrome
      result.onerror = () => resolve(false)
    } catch {
      // Safari
      resolve(false)
    }
  })
}
